import React from 'react'

import BkFlowEnhancementsCardDescription from '../elements/BkFlowEnhancementsCardDescription'
import BkFlowRoomEnhancementButton from '../BkFlowRoomEnhancementButton'

import yn from 'yn'

if (process.env.REACT_APP_COMPONENT_ENHANCEMENTS_CARD_LAYOUT === 'default') {
  require('../../../styles/css/components/enhancements/layouts/bk-flow-enhancements-card-default.css')
}

const BkFlowEnhancementsCardDefault = props => {
  const {
    activeRoom,
    currencyCode,
    currencySymbol,
    currentEnhancementKey,
    enhancementCardType,
    enhancementImageSrc,
    enhancementKey,
    enhancementPrice,
    handleToggleServiceDescription,
    hotelLabels,
    isEnhancementSelected,
    keyedDetails,
    roomGroupKey,
    serviceDescriptionExpanded
  } = props

  return (
    <div
      className={isEnhancementSelected ? 'bk-flow-enhancements__card card-default active' : 'bk-flow-enhancements__card card-default inactive' }
      key={enhancementCardType[enhancementKey].serviceInventoryCode + '-' + enhancementKey}
    >
      { yn(process.env.REACT_APP_COMPONENT_ENABLE_ENHANCEMENTS_IMAGE) &&
        <div
          className="bk-flow-enhancements__card-image u-bg-image"
          style={{backgroundImage: 'url(' + enhancementImageSrc + ')'}}
        >
          <img
            className="u-element-hidden"
            src={ enhancementImageSrc }
            alt="Coming Soon"
          />
        </div>
      }

      <div className="bk-flow-enhancements__card-data">
        { keyedDetails.title ?
          <h4>{ keyedDetails.title.text }</h4>
        :
          <h4>{ hotelLabels.enhancement ? hotelLabels.enhancement : 'Enhancement'} : { enhancementCardType[enhancementKey].serviceInventoryCode }</h4>
        }

        { enhancementPrice &&
          <p className="bk-flow-enhancements__card-price u-font-bold">
            { currencySymbol}
            { enhancementPrice }&nbsp;
            { currencyCode}/{enhancementCardType[enhancementKey].servicePricingType}
          </p>
        }

        { keyedDetails.description &&
          keyedDetails.description.text &&
          <BkFlowEnhancementsCardDescription
            hotelLabels={hotelLabels}
            serviceDescription={keyedDetails.description.text}
            serviceDescriptionExpanded={serviceDescriptionExpanded}
            limitChars={100}
            serviceDescriptionEvent={() => handleToggleServiceDescription()}
          />
        }
      </div>

      <BkFlowRoomEnhancementButton
        enhancementKey={currentEnhancementKey}
        enhancementApiData={enhancementCardType[enhancementKey]}
        isEnhancementSelected={isEnhancementSelected}
        roomGroup={roomGroupKey}
        roomType={activeRoom[roomGroupKey][0][0].roomTypeCode}
        ratePlanCode={activeRoom[roomGroupKey][1][0].ratePlanCode}
      />
    </div>
  )
}

export default BkFlowEnhancementsCardDefault



// WEBPACK FOOTER //
// ./src/components/enhancements/layouts/BkFlowEnhancementsCardDefault.js